import { ApiClient } from '../../../../infra';
import { collaboratorPageFromBackend } from '../../../../domain';
/**
 * O que o conceito "monitoramentos compartilhados" pergunta ao servidor.
 *
 * Os pacientes que compartilharam com o profissional logado, e as sugestoes de
 * nome e CPF que alimentam o filtro. As sugestoes so existem nesta tela.
 *
 * Ver `collaborators.api.ts` para por que os dois deixaram de ser um `PatientApi`.
 */
export class MonitoringApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new MonitoringApi(); }
    /**
     * Os pacientes que compartilharam monitoramento com o profissional logado.
     *
     * ATENCAO aos nomes do periodo: o backend espera `periodStart` e `periodEnd`
     * (`PatientsWithLastMeasurementsRequestDto`). O painel antigo manda `dateFrom` e
     * `dateTo`, que o Jackson descarta em silencio - **o filtro de data de la nao
     * filtra nada**. Provado contra o backend em 2026-09-11: sem filtro, 13
     * pacientes; com `dateFrom` numa janela de 2020, os mesmos 13; com
     * `periodStart` na mesma janela, 0.
     */
    async fetchSharedPatients(criteria, signal) {
        const payload = {
            page: { number: 0, size: 1000000 },
            searchParameters: {
                name: criteria.name ?? null,
                cpf: criteria.cpf ?? null,
                periodStart: criteria.periodStart ?? null,
                periodEnd: criteria.periodEnd ?? null,
                /*
                 * A empresa em que o profissional esta lotado AGORA - a do cabecalho.
                 *
                 * Decidido com o cliente em 17/09/2026: ele so alcanca colaborador de
                 * empresa em que esta lotado. Nulo NAO quer dizer "todas": o servidor
                 * resolve pela unica quando ha uma, e exige empresa de qualquer modo -
                 * quem compartilhou o historico sem ter empresa e visivel so para o
                 * administrador geral.
                 */
                companyId: criteria.companyId ?? null
            }
        };
        try {
            return collaboratorPageFromBackend((await this.client.send('POST', '/v2/panel-patients/attended/search', payload, signal)));
        }
        catch (caught) {
            if (caught instanceof Error && caught.message.startsWith('404')) {
                return { elements: [] };
            }
            throw caught;
        }
    }
    /**
     * Os nomes e os CPFs que alimentam as duas listas de sugestao da tela.
     *
     * **Os dois endpoints estao QUEBRADOS no backend** (500: "Unable to locate
     * Attribute with the given name [patient] on this ManagedType [User]"), e por
     * isso as sugestoes da referencia nunca apareceram - o `.then` dela nao trata
     * erro, e o interceptador nao abre modal para 500. Aqui a falha tambem e
     * silenciosa, com a lista vazia, para a tela se comportar como la; quando o
     * backend for consertado as sugestoes aparecem sozinhas nos dois paineis.
     */
    async fetchUserNames(signal) {
        const page = (await this.client.send('GET', '/v2/panel-patients/names', undefined, signal));
        return (page.response ?? []).map((item) => item.fullName ?? '').filter((name) => name.length > 0);
    }
    async fetchUserCpfs(signal) {
        const page = (await this.client.send('GET', '/v2/panel-patients/cpfs', undefined, signal));
        return (page.response ?? []).map((item) => item.cpf ?? '').filter((cpf) => cpf.length > 0);
    }
}
//# sourceMappingURL=monitoring.api.js.map